<template>
  <div class="report-container">

    <div class="row text-center">
      <div class="col-md-2 d-flex align-items-center justify-content-center">
        <img src="/assets/img/logotipodelivery.webp" alt="Logo" class="logo img-fluid">
      </div>
      <div class="col-md-8">
        <h1 class="report-title">PEDIDOS POR JANELA DE ENTREGA</h1>
        <h3 class="delivery-type">TIPO DE ENTREGA: <strong>7023</strong> - Receba em Casa</h3>
      </div>
      <div class="col-md-2 text-center">
        <h2 class="store-text">LOJA</h2> 
        <p class="store-number">03</p>
        <p class="store-date">{{currentDate}}</p>
      </div>
    </div>
    <div v-for="rota in rotas">
      <div class="row text-start">
        <div class="col-md-12">
          <strong>ENTREGA:</strong>#{{rota.id}} {{rota.name}} 
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th class="col-num">#</th>
            <th class="col-pedido">PEDIDO</th>
            <th class="col-cliente">CLIENTE / FONE</th>
            <th class="col-endereco">ENDEREÇO / NÚMERO / COMPLEMENTO</th>
            <th class="col-pagamento text-center">PAGAMENTO</th>
            <th class="col-caixas">CAIXAS</th>
            <th class="col-recebimento">RECEBIMENTO</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(order, index) in rota.Pedidos" :key="order.id">
            <td>{{ index + 1 }}</td>
            <td>{{ order.numero_pedido }}</td>
            <td><strong>{{ order.nome_cliente }}</strong><br />{{ order.telefone_cliente }}</td>
            <td>{{ order.endereco1_cliente+ " " + order.endereco2_cliente }}, {{  order.numero_cliente  }} - {{  order.bairro_cliente  }}, {{  order.cidade_cliente  }}/{{order.estado_cliente}}</td>
            <td>
              <div class="text-center">
                {{ order.pagamento_status=='paid' ? 'PAGO':'NÃO PAGO' }}<br>
                {{ order.status_pagamento_gateway=='CONFIRMADO' ? 'GETNET':'PAGA NA ENTREGA' }}
              </div>
            </td>
            <td>
              <div v-html="formatarEmbalagensPorTipo(order.embalagens)"></div>
                             

            </td>
            <td>

              <div class="col-md-2 text-center">
                <p class="text-nome">NOME/SOBRENOME:</p>
                <p class="text-docs">RG/CPF</p>
              </div>
              

            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>



<style scoped>
.report-container {
  font-family: Arial, sans-serif;
  max-width: 1200px;
  margin: auto;
  border: 1px solid #ccc;
  padding: 20px;
  background: #fff;
}



.report-container .col-num {
  width: 5%;
}
.report-container .col-pedido {
  width: 10%;
}
.report-container .col-cliente {
  width: 20%;
}
.report-container .col-endereco {
  width: 30%;
}
.report-container .col-pagamento {
  width: 15%;
}
.report-container .col-caixas {
  width: 10%;
}
.report-container .col-recebimento {
  width: 10%;
}

.report-container h1 {
  font-size: 15px;  /* Reduzindo o tamanho do título */
  text-align: center;
}

.report-container h2 {
  font-size: 18px;
  text-align: center;
}


.report-container .text-nome {
  font-size: 1em;
  font-weight: bold;
  color: black;
}
.report-container .text-docs {
  font-size: 1em;
  font-weight: bold;
  color: black;
}


.report-container h3 {
  font-size: 18px;
  text-align: center;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #000;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.report-container .logo img {
  height: 60px;
}

.report-container .report-title {
  text-align: center;
}

.report-container .store-info {
  text-align: right;
}



.report-container .rota {
  text-align: right;
}
.report-container .store-text {
  font-size: 1em;
  font-weight: bold;
  color: black;
}
.report-container .store-number {
  font-size: 2em;
  font-weight: bold;
  color: black;
  border:1px solid black;
}

.report-container .store-date {
  font-size: 10px;
  font-weight: bold;
  color: black;
}


.report-container .text-muted {
  font-size: 2em;
  font-weight: bold;
  color: black;
}

.report-container  tr{


  border-bottom: 1px solid rgb(85, 85, 85);
}

table {
  width: 100%;
  border-collapse: collapse;
}

th {
  text-align: left;
  font-size: 10px;
}

td {
  font-size: 10px;
}


th {
  background: #ddd;
  font-weight: bold;
}

</style>

<script>

import { defineComponent, ref } from 'vue';

import Loading from "./components/Loading.vue";

import fintailapi from "../api";
import moment from 'moment';

export default defineComponent({
  name: "tables",
  components: {
    Loading
  },
  data() {
    return {
      rotas:[],
      currentDate:moment().format("DD/MM/YYYY - HH:mm:ss"),
      deliveryType: "7023 - Receba em Casa",
      deliveryDate: "22/01/2025 (QUARTA-FEIRA)",
      startTime: "08:00",
      endTime: "10:00",
      storeNumber: "03",
      reportDate: "22/01/2025 - 14:00",
      orders: [
        {
          id: 1,
          pedido: "00573539",
          cliente: "Claudia Ragazzi",
          fone: "14977371971",
          endereco: "Rua Capitão José Ribeiro, 112 - Jardim Regina - Jaú/SP",
          pagamento: "NÃO PAGO - PAGA NA ENTREGA",
          caixas: "SECAS: 2012 / FRIAS: 0052",
          recebimento: "RICGIF",
        },
        {
          id: 2,
          pedido: "00573627",
          cliente: "Amanda Botelho",
          fone: "19896887838",
          endereco: "Rua Otávio Paes de Barros, 39 - Jardim das Palmeiras - Jaú/SP",
          pagamento: "NÃO PAGO - PAGA NA ENTREGA",
          caixas: "SECAS: 2019, 2036",
          recebimento: "RICGIF",
        },
        // Adicione mais pedidos conforme necessário...
      ],
    };
  },
  async mounted() {
    
    this.getRotas(0)

  },
  methods: {

    formatarEmbalagensPorTipo(embalagens) {
      const agrupado = {};

      // Itera sobre as embalagens
      embalagens.forEach(embalagem => {

        if(embalagem.unidadetransporte){;

          const tipo = embalagem.unidadetransporte.tipo.toUpperCase(); // "SECA" ou "FRIA"
          const codigo = embalagem.codigo_embalagem;

          // Verifica se o tipo já existe no objeto de agrupamento
          if (agrupado[tipo]) {
            agrupado[tipo].push(codigo);
          } else {
            agrupado[tipo] = [codigo];
          }
        }
      });

      // Formata a resposta no formato desejado
      const resultado = [];
      for (const tipo in agrupado) {
        resultado.push(`${tipo}:${agrupado[tipo].join(',')}`);
      }

      return resultado.join('<br>');
    },

    getRotas(offset) {
        this.isLoading = true
        fintailapi
        .get(`/rotas?offset=${offset}&limit=10`)
        .then((response) => {

          this.current_page = offset;

          this.rotas = response.data;

          this.isLoading = false

        })
        .catch((error) => {

        })

    },
   },
});
</script>